import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs7() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`VII.`}
            <br />
            {`Autorské právo a licenční ujednání`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Uživatel (subjekt údajů) bere na vědomí, že veškerý obsah webové stránky, tj. zejména audio a video obsah, fotografie, grafická díla a další prvky obsažené na webové stránce nebo dostupné v rámci služby jsou chráněny autorským právem. `}</li>
            <li>{`Databáze nacházející se na webové stránce nebo dostupné v rámci služby jsou chráněny zvláštním právem pořizovatele databáze, jímž je poskytovatel. `}</li>
            <li>{`Není-li s poskytovatelem smluveno písemně jinak, může k oprávněnému užití autorských děl či databází uživatelem dojít pouze v rámci uživatelského rozhraní služby.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`Uživatel není oprávněn obsah webové stránky či služby kopírovat, ukládat či duplikovat, spojovat s jinými autorskými díly či s autorskými díly nakládat jinak, než jejich užitím v rámci služby. Uživatel není oprávněn obcházet technické prostředky určené k ochraně obsahu. `}</li>
            <li>{`Uživatel bere na vědomí, že počítačové programy tvořící webovou stránku jsou chráněny autorským právem. Uživatel se zavazuje, že nebude vykonávat žádnou činnost, která by mohla jemu nebo třetím osobám umožnit neoprávněně zasahovat či užívat počítačové programy, kdy vykonavatelem majetkových práv je poskytovatel.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs7;
